import React from "react";
import { Typography, Grid, Button } from "@mui/material";
import PropTypes from "prop-types";

import ServiceEditCard from "../ServiceEdit";
import { isEmpty } from "../../common/helpers";

const HeaderContent = ({
  title, subtitle, irA, buttonTitle, style, showButton = true
}) => (
  <>
    <Grid
      size={{ xs: 12, md: 6 }}
      sx={{
        alignItems: "stretch",
        ...(style && typeof style === "object" ? style : {})
      }}>
      <Typography variant="h6" color="primary">
        {title}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {subtitle}
      </Typography>
    </Grid>
    {showButton && (
      <Grid
        size={{ xs: 12, md: 6 }}
        sx={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}
      >
        <Button
          variant="contained"
          size="small"
          sx={{ minWidth: "30%", fontSize: "14px", textTransform: "none" }}
          onClick={irA}
        >
          {buttonTitle}
        </Button>
      </Grid>
    )}
  </>
)

const TabService = ({
  services, direcciones, title, subtitle, type, borrador = false,
  irA, eliminar
}) => {

  return (
    <Grid container spacing={2} sx={{ padding: 0, marginTop: 3 }}>
      <HeaderContent
        title={title}
        subtitle={subtitle}
        showButton={!borrador}
        irA={() => irA(`/user/crear-servicio/${type === "SERVICE" ? 0 : 1}`)}
        buttonTitle={type == "SERVICE"
          ? "Nuevo servicio"
          : "Nueva página independiente"
        }
      />
      {
        !isEmpty(services)
        && services.map((item, index) =>
          <ServiceEditCard
            key={`${type}${index}`}
            eliminar={eliminar}
            servicio={item}
            direcciones={direcciones}
            type={type}
            borrador={borrador}
            irA={irA}
          />
        )
      }
    </Grid>
  )
}

TabService.propTypes = {
  irA: PropTypes.func.isRequired,
  borrador: PropTypes.bool,
  services: PropTypes.array.isRequired,
  direcciones: PropTypes.array,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  eliminar: PropTypes.func.isRequired,
}

export default TabService;
